/* eslint-disable import/no-anonymous-default-export */
export default {
	borderRadius: 4,
};
